/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coinvestments_Canceldeal_Modal_Confirmationrequired3Inputs */

const en_coinvestments_canceldeal_modal_confirmationrequired3 = /** @type {(inputs: Coinvestments_Canceldeal_Modal_Confirmationrequired3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Please type 'cancel' to confirm`)
};

/**
* | output |
* | --- |
* | "Please type 'cancel' to confirm" |
*
* @param {Coinvestments_Canceldeal_Modal_Confirmationrequired3Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const coinvestments_canceldeal_modal_confirmationrequired3 = /** @type {((inputs?: Coinvestments_Canceldeal_Modal_Confirmationrequired3Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coinvestments_Canceldeal_Modal_Confirmationrequired3Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_coinvestments_canceldeal_modal_confirmationrequired3(inputs)
});
export { coinvestments_canceldeal_modal_confirmationrequired3 as "coInvestments_cancelDeal_modal_confirmationRequired" }